import React, { useState, useEffect } from 'react';
import styles from './PromoPage.module.css';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { api } from '../../utils/api';
import { transformPromos } from '../../utils/transformers';
import Loader from '../../components/Loader/Loader';
import cn from 'classnames';

interface PromoBlockProps {
  title: string;
  text: string;
  promo?: string;
  bgColor: string;
}

const PromoBlock = ({ title, text, promo, bgColor }: PromoBlockProps) => {
  return (
    <div className={cn(styles.block, styles[bgColor])}>
      <div className={styles.promo_content}>
        <h3>{title}</h3>
        <p className='text-2_font'>{text}</p>
      </div>
      <img src={promo} alt={title} />
    </div>
  );
};

export default function PromoPage() {
  const [promos, setPromos] = useState<PromoBlockProps[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const promosData = await api.promo.getAll();
        const transformedPromos = transformPromos(promosData);
        setPromos(transformedPromos);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <Helmet>
        <title>Акции и скидки | Восток Строй</title>
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vostokstroy.com/support" />
        <meta property="og:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />
        <meta property="og:url" content="https://vostokstroy.com/support" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
      </Helmet>

      <Header theme='light' />
      <div className={styles.promo_page}>
        <h2>Акции и скидки</h2>
        <div className={styles.promo_blocks}>
          {promos.length > 0 ? (
            promos.map((promo) => (
              <PromoBlock
                key={promo.title}
                title={promo.title}
                text={promo.text}
                promo={promo.promo}
                bgColor={promo.bgColor}
              />
            ))
          ) : (
            <div className={styles.promo_empty}>
              <p>Сейчас нет активных акций</p>
            </div>
          )}
        </div>
      </div>
      <Footer theme='light' />
    </>
  );
}
